// extracted by mini-css-extract-plugin
export default {"container":"App_container__qr+m-"};